export const SEARCH_PARAMS = {
  EMAIL: 'Email',
  LAST_NAME: 'Прізвище',
  PHONE: 'Телефон',
  USER_TYPE: 'Тип користувача',
} as const;

export const SEARCH_PARAMS_LIST = Object.values(SEARCH_PARAMS);

export const SEARCH_PARAMS_FILES = {
  INDEX: {
    label: 'Індекс',
    field: 'public_indexes_name',
    id: '1',
  },
  DOCUMENT_NUMBER: {
    label: 'Номер документу',
    field: 'public_agreements_name',
    id: '2',
  },
  UPLOAD_DATE: {
    label: 'Дата завантаження',
    field: 'public_files_upload_date',
    id: '3',
  },
  FILMED_DATE: {
    label: 'Дата зйомки',
    field: 'public_files_filmed_date',
    id: '4',
  },
  VIN_NUMBER: {
    label: 'VIN номер',
    field: 'public_insurance_objects_name',
    id: '5',
  },
  STATE_LICENSE_PLATE: {
    label: 'Держ. Ном. Знак',
    field: 'public_agreements_registration_plate',
    id: '6',
  },
  EDRPOU_RNOKPP: {
    label: 'ЄДРПОУ/РНОКПП',
    field: 'public_insurance_objects_name',
    id: '7',
  },
  TAGS: {
    label: 'Мітки',
    field: 'public_tags_name',
    id: '8',
  },
  STATUSES: {
    label: 'Статуси',
    field: 'public_files_status', // Updated to match mapping
    id: '9',
  },
  DIRECTORY: {
    label: 'Дирекція',
    field: 'public_directories_name',
    id: '10',
  },
};

export const SEARCH_PARAMS_FILES_LIST = Object.values(SEARCH_PARAMS_FILES);
